import { configureStore } from "@reduxjs/toolkit";
import serviceReducer from './slices/serviceSlice'
import doctorReducer from './slices/doctorSlice'
import testReducer from './slices/testSlice'
import OpdDoctorReducer from './slices/doctorGridSlice'
export const store = configureStore({
    reducer:{
        services:serviceReducer,
        doctor:doctorReducer,
        // test:testReducer,
        doctorGrid:OpdDoctorReducer
    }
}) 


// 👇 Log initial state
console.log("Initial diagnostic services Redux Store:", store.getState());

// 👇 Log updates whenever the store changes
store.subscribe(() => {
  console.log("Updated  diagnostic services Redux Store:", store.getState());
});



export default store;